import { defineStore } from 'pinia'
import { ref } from 'vue'
import { EventApi } from '@/api/events/events';
import { Event } from '@/api/events/events';

export const useEventStore = defineStore('event', () => {
    const _events = ref<Event[]>([])
    const _eventsAdmin = ref<Event[]>([])

    // axios.get('/api/events').then(response => {
    //   _events.value = response.data;
    // })

    EventApi.getAll().then((response) => {
        _events.value = response;
    })
    EventApi.getAllAdmin().then((response) => {
        _eventsAdmin.value = response;
    })

    const getEvents = () => {
        return _events;
    }

    const getEventsAdmin = () => {
        return _eventsAdmin;
    }

    return { getEvents, getEventsAdmin };
})
